import React from 'react';
import { Redirect } from 'react-router-dom';
import GenericContractManagement from './Generic/ContractManagement.container';
import MarkersContractManagement from './Markers/ContractManagement.container';
import groupings from '../../Common/Constants/Groupings';
import { isNullUndefinedOrEmpty } from '../../utils';
import useGrouping from 'Common/Utils/Hooks/useGrouping';

const ContractManagementContainer = () => {
	const grouping = useGrouping();
	if (isNullUndefinedOrEmpty(grouping)) {
		return <Redirect push to="/"></Redirect>;
	}

	return grouping === groupings.Marker ? <MarkersContractManagement grouping={grouping} /> : <GenericContractManagement grouping={grouping} />;
};

export default ContractManagementContainer;
